import Editr from './editor/Editr.vue';
import _bus from './editor/bus';

const plugin = {
	install: (Vue, userOptions = {}) => {
		_bus.options = { ..._bus.options, ...userOptions };
		Vue.component('wysiwyg', Editr);
	},

	component: Editr
};

export const Wysiwyg = Editr;
export const bus = _bus;



export default plugin;
